import { Dispatch } from "redux";
import { Action, ActionType } from "../actions";
import PluginService from "../../services/pluginService";
import { IDeliveryType, IPluginConfiguration } from "../../models/configuration/plugin/IConfiguration";
import { hasPluginConfigChanges } from "../../utils/pluginConfigChangeDetector";

// This action creator gets the server config values from an api call or state
const saveConfigDeliveryTypesData = (configId: string, updatedDeliveryTypes: IDeliveryType[], AllowMultiDelivery: boolean, token: string | null) => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({ type: ActionType.SAVE_CONFIG_PLUGIN_DATA });

        try {

            const { data: pluginConfiguration, persistedData } = getState().configPlugInData;

            if (!pluginConfiguration) {
                throw new Error(" No PluginConfiguration available in state to save");
            }

            if (!updatedDeliveryTypes || updatedDeliveryTypes.length === 0) {
                throw new Error("No Delivery Types to save");
            }

            // Using the Plug In State Data update the Delivery Types
            const updatedConfig = {
                ...pluginConfiguration.Configuration,
                DeliveryTypes: updatedDeliveryTypes,
                AllowMultiDelivery: AllowMultiDelivery
            }

            const hasChanges = hasPluginConfigChanges(updatedConfig, persistedData?.Configuration);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                    payload: { "Configuration": updatedConfig }
                });
                return false;
            }

            const configToSave = {
                ...updatedConfig,
                LastUpdateUtc: new Date().toISOString()
            };

            const requestBody = {
                "ConfigurationId": configId,
                "EncompassInstanceId": getState().appSlice.encompassInstanceId,
                "Configuration": configToSave
            }

            await new PluginService().saveEpcApiConfig<IPluginConfiguration>(token, "plugin", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                payload: { "Configuration": configToSave }
            });
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_PERSISTED,
                payload: { "Configuration": configToSave }
            });

            return true;

        } catch (error: any) {
            const payloadErrorMessage = `Failed to save delivery types data: (${error.message})`;
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_FAILURE,
                payload: payloadErrorMessage,
            });

            return Promise.reject(payloadErrorMessage);
        }
    }
}

export default saveConfigDeliveryTypesData;